import React, { lazy } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Outlet, Route, Routes } from "react-router-dom";
import { OnboardingProvider } from "./contexts/OnboardingContext";
import { AccountSession, AuthProvider } from "./contexts/AuthContext";
import { VideoDraftProvider } from "./components/video/VideoDraftProvider";

import RouteLoader from "./components/RouteLoader";
import { UsageAnalyticsProvider } from "./contexts/UsageAnalyticsProvider";

const Register = lazy(() => import("./components/pages/register"));
const Dashboard = lazy(() => import("./components/pages/dashboard"));
const Videos = lazy(() => import("./components/pages/videos"));
const Login = lazy(() => import("./components/pages/login"));
const AccountRecovery = lazy(() => import("./components/pages/account-recovery"));
const Video = lazy(() => import("./components/pages/video"));
const Landing = lazy(() => import("./components/pages/landing"));
const AdminVideos = lazy(() => import("./components/pages/adminVideos"));
const ReviewerVideos = lazy(() => import("./components/pages/reviewerVideos"));
const PrivacyPolicy = lazy(() => import("./components/pages/privacyPolicy"));
const CasePrepList = lazy(() => import("./components/pages/casePrepList"));
const CasePrepDay = lazy(() => import("./components/pages/casePrepDay"));
const CasePrepCase = lazy(() => import("./components/pages/casePrepCase"));
const CasePrepPrint = lazy(() => import("./components/pages/casePrepPrint"));
const Settings = lazy(() => import("./components/pages/settings"));
const OnboardingPreview = lazy(() => import("./components/pages/onboardingPreview"));
const GuidedWalkthrough = lazy(() => import("./components/onboarding/GuidedWalkthrough"));

export default function App() {
  return (
    <AuthProvider>
      <OnboardingProvider>
        <RouteLoader>
        <Routes>
          {/* Show landing page when not logged in, show dashboard when logged in. */}
          <Route path="/" exact element={<Landing />} />
          <Route element={<AccountSession><UsageAnalyticsProvider><VideoDraftProvider><Outlet /></VideoDraftProvider></UsageAnalyticsProvider></AccountSession>}>
            <Route path="/dashboard" exact element={<Dashboard />} />
            <Route path="/videos" exact element={<Videos />} />
            <Route path="/video/:uid/:file" exact element={<Video />} />
            <Route path="/case-prep" exact element={<CasePrepList />} />
            <Route path="/case-prep/:orDayId" exact element={<CasePrepDay />} />
            <Route path="/case-prep/:orDayId/cases/:caseId" exact element={<CasePrepCase />} />
            <Route path="/case-prep/:orDayId/print" exact element={<CasePrepPrint />} />
            <Route path="/settings" exact element={<Settings />} />
            <Route path="/onboarding" exact element={<GuidedWalkthrough />} />
            <Route path="/admin" exact element={<AdminVideos />} />
            <Route path="/reviewer" exact element={<ReviewerVideos />} />
          </Route>
          <Route path="/register" exact element={<Register />} />
          <Route path="/login" exact element={<Login />} />
          <Route path="/account-recovery" exact element={<AccountRecovery />} />
          <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
          {process.env.NODE_ENV === "development" && (
            <Route
              path="/onboarding-preview"
              exact
              element={<OnboardingPreview />}
            />
          )}
        </Routes>
        </RouteLoader>
      </OnboardingProvider>
    </AuthProvider>
  );
}
